var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Stack,{staticClass:"stk-p-8"},[_c(_setup.Title,[_vm._v("\n    Create Alert\n  ")]),_vm._v(" "),_c(_setup.MetricAlertCreateView)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }